import { Project } from "@brg/api";
import { getProjectImages } from "shared/pages/project/sections/ps-image";

const getImages = (project: Project<'Global'>, lang: string) => {
    //@ts-ignore
    const isBilingual = !!project?.isBilingual;
    if (isBilingual) {
      const images = lang === 'en' ? project?.titleImages_en : project.titleImages;
      return images || [];
    } else {
      return getProjectImages(project, lang)
    }
  }

  export default getImages;import { Project } from "@brg/api";
import { getProjectImages } from "shared/pages/project/sections/ps-image";

const getImages = (project: Project<'Global'>, lang: string) => {
    //@ts-ignore
    const isBilingual = !!project?.isBilingual;
    if (isBilingual) {
      const images = lang === 'en' ? project?.titleImages_en : project.titleImages;
      return images || [];
    } else {
      return getProjectImages(project, lang)
    }
  }

  export default getImages;